var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUsers = function SvgIconUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10c3.038 0 5.5 2.216 5.5 4.95s-11 2.733-11 0S3.462 10 6.5 10M14.252 10.5c2.347 0 4.25 1.741 4.25 3.89 0 1.147-2.429 1.68-4.69 1.601.117-.312.188-.66.188-1.041a6.53 6.53 0 0 0-1.454-4.123 4.6 4.6 0 0 1 1.706-.327M14.161 3.875a2.5 2.5 0 1 1 .001 4.999 2.5 2.5 0 0 1 0-4.999M6.501 2.75a3 3 0 1 1 .001 5.999 3 3 0 0 1-.001-5.999"
  })));
};
export default SvgIconUsers;